module.exports = __webpack_public_path__ + "static/azure-fundamentals-5edd9899764c5d720fefa6df48afd7f5.png";